export enum QuizType {
    SAMPLE = 'sample',       // @deprecated use QuizMode.PRACTICE
    FULL = 'full',          // @deprecated use QuizMode.FULL
    CATEGORY = 'category'    // @deprecated use QuizMode.CATEGORY
}

// The exam banks the backend actually serves. The retired `lcsw_free` (the old
// "LCSW 30 Free Quiz") is aliased to `lcsw` on read by the backend — there is no
// free tier and no free type. Never default/fall back to it. Legacy sessions
// with `testType: 'lcsw_free'` still render via string-keyed label aliases.
export enum TestType {
    LCSW = 'lcsw',
    LBSW = 'lbsw',
    LMSW = 'lmsw'
}

export enum QuizMode {
    PRACTICE = 'practice',    // Short practice sessions
    FULL = 'full',           // Full-length simulated exam
    CATEGORY = 'category'    // Category-focused practice
} 